var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  보고서 양식이 없습니다.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }